import { useState } from "react";
import ConstellationBg from "./ConstellationBg";
import './Login.css';
import { logIn } from '../../Services/User.js';
import { useTheme } from '../../Hooks/useTheme';
import jwt from 'jwt-decode';
import logoImg from '../../assets/logIn/C-360.png';
import f360Logo from '../../assets/logIn/fundacion360.png';
import DialogModal from '../Modals/dialogModal';

const ROLE_CONTENT = {
    student: {
        tag: "Plataforma estudiantil",
        title: "Tu espacio de aprendizaje",
        sub: "Accedé a tus cursos, actividades y calificaciones en un solo lugar.",
    },
    staff: {
        tag: "Panel de gestión",
        title: "Administrá tu campus",
        sub: "Gestioná cursos, usuarios y contenidos desde el panel central.",
    },
};

function Lform() {
    const [theme, toggleTheme] = useTheme();
    const [role, setRole] = useState('student');
    const [dni, setDni] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showString, setShowString] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        const rsp = await logIn(dni, password);
        if (rsp?.error !== 'Unauthorized' && rsp?.token_type === 'bearer') {
            const decoded = jwt(rsp.access_token);
            if (decoded.id_user_type !== 1) {
                setShowString("Estas credenciales corresponden a un docente o administrador. Ingresá desde el panel de gestión.");
                setShowModal(true);
            } else {
                localStorage.setItem('access_token', rsp.access_token);
                window.location.replace('?');
            }
        } else {
            setShowString("No fue posible validarse. Revisá tus credenciales e intentá de nuevo.");
            setShowModal(true);
        }
    };

    const content = ROLE_CONTENT[role];

    return (
        <>
            <div className="login-root">
                <ConstellationBg theme={theme} />

                <button
                    className="login-theme-toggle"
                    onClick={toggleTheme}
                    title={theme === 'dark' ? 'Modo claro' : 'Modo oscuro'}
                >
                    {theme === 'dark' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
                            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                            <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
                            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                        </svg>
                    )}
                </button>

                <div className="login-wrapper">
                <div className="login-side">
                    <img src={logoImg} alt="Campus F-360" className="login-side-brand-logo" />
                    <span className="login-side-tag">{content.tag}</span>
                    <div key={role} className="login-side-content">
                        <h1 className="login-side-title">{content.title}</h1>
                        <p className="login-side-sub">{content.sub}</p>
                    </div>
                    <a
                        href="https://www.fundacion360.com.ar"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="side-f360-link"
                    >
                        <img
                            src={f360Logo}
                            alt="Fundación 360"
                            className="side-f360-logo"
                        />
                    </a>
                </div>

                <div className="login-card">
                    <img
                        src={logoImg}
                        alt="Campus F-360"
                        className={`login-logo${theme === 'dark' ? ' login-logo-white' : ''}`}
                    />

                    <div className="login-role-tabs">
                        <button
                            type="button"
                            className={`login-role-tab${role === 'student' ? ' active' : ''}`}
                            onClick={() => setRole('student')}
                        >
                            Estudiante
                        </button>
                        <button
                            type="button"
                            className={`login-role-tab${role === 'staff' ? ' active' : ''}`}
                            onClick={() => setRole('staff')}
                        >
                            Docente
                        </button>
                    </div>

                    <form onSubmit={handleSubmit} className="login-form">
                        <label htmlFor="dni">DNI</label>
                        <input
                            type="number"
                            id="dni"
                            placeholder="Ingresa tu DNI"
                            onChange={e => setDni(e.target.value)}
                        />

                        <label htmlFor="password">Clave</label>
                        <div className="password-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                placeholder="Ingresa tu clave"
                                onChange={e => setPassword(e.target.value)}
                            />
                            <button
                                type="button"
                                className="eye-btn"
                                onClick={() => setShowPassword(v => !v)}
                                aria-label={showPassword ? "Ocultar clave" : "Mostrar clave"}
                            >
                                {showPassword ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                                        <line x1="1" y1="1" x2="23" y2="23"/>
                                    </svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                        <circle cx="12" cy="12" r="3"/>
                                    </svg>
                                )}
                            </button>
                        </div>

                        <button
                            type="button"
                            className="recovery-link"
                            onClick={() => {
                                setShowModal(true);
                                setShowString("Para recuperar su clave contactese con administración.");
                            }}
                        >
                            ¿Olvidaste tu clave?
                        </button>

                        <button type="submit" className="login-btn">Ingresar</button>
                    </form>
                </div>
                </div>
            </div>

            <DialogModal showModal={showModal} setShowModal={setShowModal}>
                <h3>{showString}</h3>
            </DialogModal>
        </>
    );
}

export default Lform;
